import React from "react";
import { Link } from "gatsby";
import {
  FaShieldAlt,
  FaCloud,
  FaHeadset,
  FaRocket,
  FaLock,
  FaUsersCog,
  FaClipboardCheck,
  FaExclamationTriangle,
  FaIndustry,
} from "react-icons/fa";

import starIcon from "../../static/images/star-icon.png";

const OurSolutions = () => {
  return (
    <section className="solutions-area pt-100 pb-70">
      <div className="container">

        {/* ================= Section Header ================= */}

        <div className="section-title">

          <span className="sub-title">
            <img src={starIcon} alt="star" />
            Business Outcomes We Help Create
          </span>

          <h2>
            From Microsoft 365 Setup to Secure Digital Workplace Maturity
          </h2>

          <p>
            CloudLogic supports organisations across the full Microsoft cloud
            journey: discovery, licensing, tenant setup, migration, optimisation,
            SharePoint and Teams collaboration, automation, security,
            governance, and compliance readiness.
          </p>

        </div>

        <div className="solutions-group-wrap">

          {/* ================= Cloud Problems ================= */}

          <div className="solutions-group">

            <div className="group-header">

              <h3>
                Stage 1 and 2: Build and Optimise the Microsoft Foundation
              </h3>

              <p>
                Whether you are starting from legacy systems or already using
                Microsoft 365, CloudLogic helps create a cleaner, more scalable
                environment that supports growth and day-to-day productivity.
              </p>

            </div>

            <div className="row">

              <div className="col-lg-4 col-md-6">

                <div className="single-solutions-box">

                  <div className="icon">
                    <FaCloud size={34} />
                  </div>

                  <h4>
                    Microsoft 365 Tenant Setup & Migration
                  </h4>

                  <p>
                    Assess requirements, select licensing, create the tenant,
                    configure users, migrate email and data, and establish the
                    right Microsoft 365 foundation from the beginning.
                  </p>

                </div>

              </div>

              <div className="col-lg-4 col-md-6">

                <div className="single-solutions-box">

                  <div className="icon">
                    <FaRocket size={34} />
                  </div>

                  <h4>
                    Tenant Health & Licensing Optimisation
                  </h4>

                  <p>
                    Review existing users, licences, groups, permissions,
                    sharing, security posture, and productivity settings to
                    reduce waste and improve operational control.
                  </p>

                </div>

              </div>

              <div className="col-lg-4 col-md-6">

                <div className="single-solutions-box">

                  <div className="icon">
                    <FaHeadset size={34} />
                  </div>

                  <h4>
                    Managed Microsoft Cloud Support
                  </h4>

                  <p>
                    Keep Microsoft 365 and Azure easier to run with ongoing
                    administration, support, troubleshooting, monitoring,
                    security hardening, and continuous improvement.
                  </p>

                </div>

              </div>

            </div>

          </div>

          {/* ================= Security & Compliance ================= */}

          <div className="solutions-group">

            <div className="group-header">

              <h3>
                Stage 3 and 4: Enhance, Secure and Govern the Digital Workplace
              </h3>

              <p>
                Once the foundation is in place, CloudLogic helps organisations
                improve collaboration, automate work, secure identity, protect
                data, and create governance that can scale.
              </p>

            </div>

            <div className="row">

              <div className="col-lg-4 col-md-6">

                <div className="single-solutions-box">

                  <div className="icon">
                    <FaShieldAlt size={34} />
                  </div>

                  <h4>
                    SharePoint, Teams & OneDrive Solutions
                  </h4>

                  <p>
                    Build modern document management, collaboration spaces,
                    knowledge management, secure file sharing, and team
                    workspaces that reduce scattered information.
                  </p>

                </div>

              </div>

              <div className="col-lg-4 col-md-6">

                <div className="single-solutions-box">

                  <div className="icon">
                    <FaUsersCog size={34} />
                  </div>

                  <h4>
                    Identity, Defender, Intune & Security Controls
                  </h4>

                  <p>
                    Strengthen Entra ID, MFA, Conditional Access, Microsoft
                    Defender, endpoint controls, admin roles, onboarding,
                    offboarding, and security monitoring.
                  </p>

                </div>

              </div>

              <div className="col-lg-4 col-md-6">

                <div className="single-solutions-box">

                  <div className="icon">
                    <FaLock size={34} />
                  </div>

                  <h4>
                    Power Platform & Workflow Automation
                  </h4>

                  <p>
                    Improve productivity with Power Automate, Power Apps,
                    workflow automation, approvals, forms, and process
                    improvements built around real operating needs.
                  </p>

                </div>

              </div>

            </div>

          </div>

          {/* ================= Assessment Offer ================= */}

          <div className="solutions-group">

            <div className="group-header">

              <h3>
                Stage 5: Governance, Compliance and Advisory Support
              </h3>

              <p>
                For compliance-driven organisations, CloudLogic helps turn
                Microsoft cloud controls into clearer governance, audit
                readiness, risk management, and ongoing advisory support.
              </p>

            </div>

            <div className="row">

              <div className="col-lg-4 col-md-6">

                <div className="single-solutions-box">

                  <div className="icon">
                    <FaClipboardCheck size={34} />
                  </div>

                  <h4>
                    Microsoft 365 Health Check
                  </h4>

                  <p>
                    Review tenant health, licensing, productivity, security,
                    identity, sharing, data protection, and governance to
                    identify the best improvement path.
                  </p>

                </div>

              </div>

              <div className="col-lg-4 col-md-6">

                <div className="single-solutions-box">

                  <div className="icon">
                    <FaExclamationTriangle size={34} />
                  </div>

                  <h4>
                    Compliance Readiness Assessment
                  </h4>

                  <p>
                    Map Microsoft controls to NIST CSF, Essential Eight, ISO
                    27001, PCI DSS, HIPAA, SOC 2, CIS Controls, GDPR, and APRA
                    CPS 234 readiness where relevant.
                  </p>

                </div>

              </div>

              <div className="col-lg-4 col-md-6">

                <div className="single-solutions-box">

                  <div className="icon">
                    <FaIndustry size={34} />
                  </div>

                  <h4>
                    Trusted Technology Advisor
                  </h4>

                  <p>
                    Provide ongoing guidance for business owners, schools,
                    healthcare providers, professional services, financial
                    services, and compliance-driven organisations.
                  </p>

                </div>

              </div>

            </div>

          </div>

          {/* ================= CTA ================= */}

          <div className="solutions-main-cta text-center">

            <h3>
              Want a clearer Microsoft cloud growth and governance roadmap?
            </h3>

            <p>
              Start with a Microsoft 365 Health Check to understand your tenant,
              licensing, collaboration, security, governance, compliance, and
              productivity opportunities.
            </p>

            <Link to="/contact" className="default-btn">
              Book Microsoft 365 Health Check
            </Link>

          </div>

        </div>
      </div>
    </section>
  );
};

export default OurSolutions;
